import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";
import { CommonService } from "../../../../shared/services/common.service";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import { AssignUserToNewGroupRequest, FetchGroupFilterRequest } from "../../core/manage-users.actions";
import {
  assignGroupLoading,
  editUserStatusInfo,
  groupFilter
} from "../../core/manage-users.selectors";
import { Filter } from "../../../../../models/filter";
import { profile } from 'src/app/modules/shared/core/shared.selectors';
import { roles, sortOrderMap } from 'src/app/modules/shared/constants/common.constants';

@Component({
  selector: 'app-change-participants-group',
  templateUrl: './change-participants-group.component.html',
  styleUrls: ['./change-participants-group.component.css']
})
export class ChangeParticipantsGroupComponent implements OnInit, OnDestroy {
  @Input() data: any

  participantName: string;
  currentParticipantGroupStatus: string;
  currentParticipantGroupName: string;
  groupFilterList: Filter;
  form = new FormGroup({
    group: new FormControl({ value: null, disabled: false }, {
      validators: [
        Validators.required
      ]
    }),
    searchGroup: new FormControl({ value: null, disabled: false })
  });
  errorMessages: any = {};
  errorMessageMap = {
    'group': {
      required: 'This field is required.'
    },
  };
  editUserStatusLoading: boolean = false;
  userProfile;
  loading:boolean=false;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {

    this.store
      .select((groupFilter))
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        if (data && data.list) {
          // Format group names to include date: <group name> (mm/dd/yyyy)
          const formattedList = data.list.map(item => ({
            ...item,
            value: item.startDate 
              ? `${item.value} (${this.formatDate(item.startDate)})`
              : item.value
          }));
          this.groupFilterList = {
            ...data,
            list: formattedList
          };
        } else {
          this.groupFilterList = data;
        }
      });

  }

  ngOnInit() {
    this.store.select(profile).pipe(takeUntil(this.OnDestroy)).subscribe(profile => {
      this.userProfile = profile;
      
      this.store.dispatch(FetchGroupFilterRequest({
        payload: {
          ...(this.userProfile?.role === roles.superAdmin ? { clientId: this.data?.participantData?.clientId }:{}),
          status: [1, 2, 3, 4],
          sortColumn: 'startDate',
          sortOrder: sortOrderMap.desc
        }
      }));
    })

    this.store.select(assignGroupLoading).pipe(takeUntil(this.OnDestroy)).subscribe(loading=>{
      this.loading = loading;
    })

    this.currentParticipantGroupStatus = this.data?.participantData?.groupInfo?.status?.value;
    this.currentParticipantGroupName = this.data?.participantData?.groupInfo?.name;
    this.participantName = `${this.data?.participantData?.firstName} ${this.data?.participantData?.lastName}`;


    this.store
      .select(editUserStatusInfo)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.editUserStatusLoading = data.loading
      })
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }

    this.store.dispatch(AssignUserToNewGroupRequest({
      payload: {
        role: this.data?.participantData?.role?.key,
        groupId: this.form.value.group,
        participant: {
          userId: this.data?.participantData?.userId
        },
        ...(this.userProfile.role === 1 ? { clientId: this.data?.participantData?.clientId } : {})
      }
    }))

  }

  groupsOnNextPage() {
    const search = this.form.controls['searchGroup']?.value || '';
    this.store.dispatch(FetchGroupFilterRequest({
      payload: {
        pageNumber: this.groupFilterList.pageNumber + 1,
        ...(this.userProfile?.role === roles.superAdmin ? { clientId: this.data?.participantData?.clientId } : {}),
        status: [1, 2, 3, 4],
        sortColumn: 'startDate',
        sortOrder: sortOrderMap.desc,
        ...(search ? { search } : {})
      }
    }));
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    // Check if date is valid
    if (isNaN(date.getTime())) return '';
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }
}
